import { render, staticRenderFns } from "./CreditoImposta.vue?vue&type=template&id=3a34a2e1&"
import script from "./CreditoImposta.vue?vue&type=script&lang=js&"
export * from "./CreditoImposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports